import { useGetMetrics } from '@features/enterpriseMetrics/hooks/useGetSavedMessages';
import { Autocomplete, FormControl, MenuItem, Select, TextField } from '@mui/material';
import { authContext } from '@staffedupusa/shared-components';
import { mapPlanStatusAndColor } from '@utils/companyHelper';
import {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

type LocationSearchProps = {
  selectedCompanyId: string | number;
  boost?: boolean;
  preSelect?: boolean;
  disableButtons?: boolean;
  fixWidth?: boolean;
  disbaleExpiredCompanies?: boolean;
  setSelectedCompanyId: Dispatch<SetStateAction<string | number>>;
  setIsCompanyPaid?: Dispatch<SetStateAction<boolean>>;
  handlePageNo?: (newPageNo: number) => void;
};

const LocationSearch: FC<LocationSearchProps> = ({
  disableButtons,
  preSelect,
  setIsCompanyPaid,
  boost,
  disbaleExpiredCompanies,
  selectedCompanyId,
  setSelectedCompanyId,
  handlePageNo,
  fixWidth,
}) => {
  const { authData } = useContext(authContext);
  const [companiesData, setCompaniesData] = useState<any[]>([]);

  const { metricsData, isLoadingMetrics } = useGetMetrics({
    enterprise_id: authData?.user?.enterprise?.id,
    selectedCompanyId: 'ALL',
  });

  useEffect(() => {
    if (metricsData?.companies) {
      const updatedCompaniesData = mapPlanStatusAndColor(metricsData.companies);
      if (updatedCompaniesData && preSelect) {
        setSelectedCompanyId(updatedCompaniesData?.[0]?.company_id);
      }
      setCompaniesData(updatedCompaniesData);
    }
  }, [metricsData]);

  return (
    <FormControl
      size="small"
      variant="outlined"
      sx={{ width: { xs: '100%', md: fixWidth ? '200px' : '100%' } }}
    >
      <Autocomplete
        size="small"
        options={companiesData}
        getOptionLabel={(option) =>
          `${option.name}, ${option?.s_city}, ${option?.s_state}`
        }
        value={
          companiesData.find((c) => c.company_id === selectedCompanyId) || null
        }
        onChange={(_, newValue) => {
          const selectedId = newValue?.company_id || '';
          handlePageNo && handlePageNo(1);
          setSelectedCompanyId(selectedId);
          setIsCompanyPaid &&
            setIsCompanyPaid(
              metricsData?.companies?.find(
                (company: any) => company?.company_id === selectedId,
              )?.is_company_paid,
            );
        }}
        renderInput={(params) => (
          <TextField {...params} placeholder={boost ? 'Select Company' : 'All Companies'} />
        )}
        isOptionEqualToValue={(option, value) =>
          option.company_id === value.company_id
        }
        disabled={disableButtons}
        getOptionDisabled={(option) => Boolean(disbaleExpiredCompanies && (option.plan_status === 'Expired'))}
        renderOption={(props, option) => (
          <li {...props} key={option.company_id}>
            {option.name}, {option?.s_city}, {option?.s_state}
            <span
              style={{
                color: '#fff',
                fontSize: '9px',
                fontWeight: '600',
                backgroundColor: option.color,
                marginLeft: '10px',
                padding: '1px 5px 2px',
                borderRadius: 5,
              }}
            >
              {option.plan_status}
            </span>
          </li>
        )}
      />
    </FormControl>

  );
};

export default LocationSearch;
